import { Users, ArrowRight } from "lucide-react";

const fleet = [
  {
    name: "Sedan",
    model: "Maruti Suzuki Dzire / Equivalent",
    use: "Airport transfers, executive travel",
    pax: 4,
    price: "₹850",
    image: "/brand/dzire.jpg",
  },
  {
    name: "6-Seater",
    model: "Maruti Suzuki Ertiga",
    use: "Team travel, medium groups",
    pax: 6,
    price: "₹950",
    image: "/brand/ertiga.jpg",
  },
  {
    name: "Toyota Innova Crysta",
    model: "Premium Executive",
    use: "Executive & guest transfers",
    pax: 7,
    price: "₹1,900",
    image: "/brand/crysta.jpg",
  },
  {
    name: "Tempo Traveller",
    model: "Force Traveller Luxury",
    use: "Team outings, group commute & long-distance travel",
    pax: 26,
    price: "₹4,500",
    image: "/brand/traveller.jpg",
  },
  {
    name: "Coach",
    model: "Volvo / Tata AC Coach",
    use: "Large employee shuttles, conferences & offsites",
    pax: 49,
    price: "₹8,500",
    image: "/brand/bus.jpg",
  },
  {
    name: "Premium Vehicle",
    model: "Mercedes E-Class · BMW 5 Series · Premium SUVs",
    use: "Board-level executive, VIP transfers & premium SUV chauffeur drives",
    pax: 4,
    price: "₹12,500",
    image: "/brand/premium.jpg",
  },
];

export default function Fleet() {
  return (
    <section id="fleet" className="section-pad bg-[#f6f7fb]" data-testid="fleet-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 reveal">
          <div className="max-w-2xl">
            <div className="eyebrow mb-4">Fleet Showcase</div>
            <h2 className="headline text-[34px] md:text-[44px]">
              A fleet built for every corporate need.
            </h2>
          </div>
          <p className="text-slate-600 text-[15px] md:max-w-md">
            Sample pricing shown is for airport / hotel transfers up to 35 km. Custom
            corporate contracts and shift packages are quoted separately.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-7">
          {fleet.map((v, i) => (
            <FleetCard key={v.name} {...v} delay={i * 0.08} />
          ))}
        </div>

        <p className="mt-10 text-[13px] text-slate-500 reveal">
          * Prices indicative for point-to-point transfers up to 35 km. GST extra. Final
          quote provided upon request.
        </p>
      </div>
    </section>
  );
}

function FleetCard({ name, model, use, pax, price, image, delay }) {
  return (
    <div
      data-testid={`fleet-card-${name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
      className="bg-white rounded-2xl overflow-hidden border border-slate-200 card-elevate reveal flex flex-col"
      style={{ transitionDelay: `${delay}s` }}
    >
      <div className="relative h-56 overflow-hidden bg-slate-100">
        <img
          src={image}
          alt={name}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 hover:scale-110"
        />
        <div className="absolute top-4 right-4 bg-[#F5A623] text-[#0D1B40] px-3 py-1.5 rounded-full text-[12px] font-bold flex items-center gap-1.5">
          <Users size={13} /> Up to {pax}
        </div>
      </div>
      <div className="p-6 flex flex-col flex-1">
        <div className="text-[12px] font-semibold tracking-[0.18em] text-[#F5A623] uppercase">
          {model}
        </div>
        <h3 className="mt-1.5 text-[#0D1B40] text-[22px] font-bold">{name}</h3>
        <p className="mt-2 text-slate-600 text-[14.5px] leading-relaxed">{use}</p>

        <div className="mt-5 pt-5 border-t border-slate-100 flex items-end justify-between">
          <div>
            <div className="text-[11px] tracking-[0.16em] text-slate-500 font-semibold uppercase">
              Starts From
            </div>
            <div className="text-[#0D1B40] font-extrabold text-[26px] leading-none mt-1">
              {price}
            </div>
          </div>
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              window.dispatchEvent(
                new CustomEvent("rydey:prefill", { detail: { service: name } })
              );
              const target = document.querySelector("#contact");
              if (target) {
                target.scrollIntoView({ behavior: "smooth", block: "start" });
                if (window.history && window.history.replaceState) {
                  window.history.replaceState(null, "", "#contact");
                }
              }
            }}
            className="inline-flex items-center gap-1.5 text-[13px] font-semibold text-[#0D1B40] hover:text-[#F5A623] transition-colors"
            data-testid={`fleet-quote-${name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
          >
            Get Quote <ArrowRight size={14} />
          </a>
        </div>
      </div>
    </div>
  );
}
